// eslint-disable-next-line
export function cloneDeep (objectToClone: unknown) {
    return JSON.parse(JSON.stringify(objectToClone));
}
